import RootPage from './RootPage';

export default RootPage;
